import styled from "@emotion/styled";

import { theme } from "../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Table = styled.table(props => ({
    tableLayout: "fixed",
    width: 0,
    borderCollapse: "collapse",
    borderWidth: 0,
    borderColor: theme(props).border.color,
}));

export const Root = styled.div({
    display: "flex",
    paddingBottom: 10,
});

export const FooterStop = styled.div({
    marginTop: 10,
});

export const ActionButtons = styled.div({
    display: "flex",
    justifyContent: "center",
    width: 40,
});

export const SidebarMultilineRoot = styled.table(props => ({
    tableLayout: "fixed",
    width: 0,
    borderCollapse: "collapse",
    borderWidth: 0,
    borderColor: theme(props).border.color,
    padding: 0,
}));
